import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { Observable } from 'rxjs';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { Promotion } from 'ish-core/models/promotion/promotion.model';
import { PromotionDetailsComponent } from 'ish-shared/components/promotion/promotion-details/promotion-details.component';

@Component({
  selector: 'ish-product-promotion',
  templateUrl: './product-promotion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ServerHtmlDirective, PromotionDetailsComponent],
})
export class ProductPromotionComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly displayType = input<'default' | 'simple' | 'simpleWithDetail'>('default');

  visible$: Observable<boolean>;
  promotions$: Observable<Promotion[]>;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'promotions');
    this.promotions$ = this.context.select('promotions');
  }
}
